import FdSignupBrandAwarePersonalInfoPage from "@faire/prototype-playground/workspace/yao/fd-brand-aware-personal-info";
import FdSignupEmailFirstOnProductPagesPage from "@faire/prototype-playground/workspace/yao/fd-pdp-email-first-signup";
import LegalBusinessNameMakeSkipObviousPage from "@faire/prototype-playground/workspace/yao/legal-business-name-skip";
import WebsiteOptionalV2CaptureWebsiteBeforeFirstOrderPage from "@faire/prototype-playground/workspace/yao/website-optional-v2";
import WebsiteOptionalV2CheckoutStepsAcrossWebAndAppsPage from "@faire/prototype-playground/workspace/yao/website-optional-v2-checkout-flow";
import { Route, Switch } from "react-router-dom";

export function YaoWangRoutes() {
  return (
    <Switch>
      <Route
        path="/yao/fd-brand-aware-personal-info"
        component={FdSignupBrandAwarePersonalInfoPage}
      />
      <Route
        path="/yao/fd-pdp-email-first-signup"
        component={FdSignupEmailFirstOnProductPagesPage}
      />
      <Route
        path="/yao/legal-business-name-skip"
        component={LegalBusinessNameMakeSkipObviousPage}
      />
      <Route
        path="/yao/website-optional-v2"
        component={WebsiteOptionalV2CaptureWebsiteBeforeFirstOrderPage}
      />
      <Route
        path="/yao/website-optional-v2-checkout-flow"
        component={WebsiteOptionalV2CheckoutStepsAcrossWebAndAppsPage}
      />
    </Switch>
  );
}

export const slug = "yao";
